import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import 'react-datepicker/dist/react-datepicker.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import TimeSlots from '../components/TimeSlots/index';
import {Button, buttonTypes} from '../../../../components/Button/index';
import {validationTourData, isFieldPrice} from '../../../../utils/validationUtils';
import RenderTemplates from '../components/Templates'
import Popup from '../../../../components/Popup';
import OffDates from '../components/OffDays';
import {defaultImg, createPreviewImages} from "../../../../utils/tourImages";
import './Create.scss';

class Tour extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleNewImage = this.handleNewImage.bind(this);
    this.handleNewVideo = this.handleNewVideo.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
    this.submitCreate = this.submitCreate.bind(this);
    this.handleSetError = this.handleSetError.bind(this);
    this.onNewDates = this.onNewDates.bind(this);
    this.handleAddress = this.handleAddress.bind(this);
    this.onNewDayOff = this.onNewDayOff.bind(this);
    this.state = {
      // active: true,
      cityId: null,
      tourTemplate: 'tmp2',
      title: '',
      description: '',
      categoryId: null,
      priceOnePerson: '',
      minPersons: '',
      maxPersons: '',
      tourDates: [],
      offTourDates: [],
      images: [],
      imagesPreview: {},
      video: {},
      address: '',
      cityOptions: [],
      lat: null,
      lng: null,
      error: {},
      popupData: {}
    }
  }

  static propTypes = {
    categories: PropTypes.array,
    cities: PropTypes.array,
    createTour: PropTypes.func,
    history: PropTypes.object,
    isShowPopup: PropTypes.bool,
    closePopup: PropTypes.func,
    errorTourDates: PropTypes.string,
    promiseCreateTour: PropTypes.object,
  };

  componentWillMount() {
    this.setState({imagesPreview: defaultImg()});
    this.setCityOptions(this.props.cities)
  }

  componentWillReceiveProps(next) {
    this.setCityOptions(next.cities)
  }

  createCategoriesOptions() {
    const {categories} = this.props;
    const result = [];
    for (let i = 0; i < categories.length; i++) {
      result.push(
        {value: categories[i].id, label: categories[i].name}
      )
    }
    return result
  }

  setCityOptions(cities) {
    const result = [];
    for (let i = 0; i < cities.length; i++) {
      result.push({value: cities[i].id, label: `${cities[i].city}`});
    }
    this.setState({cityOptions: result});
    return true;
  }

  checkMaxPeoplesInCity(persons) {
    const {cities} = this.props;
    const {cityId} = this.state;
    if (cities && cities.length) {
      for (let i = 0; i < cities.length; i++) {
        if (+cities[i].id === +cityId) {
          if (cities[i].vehicle && persons > cities[i].vehicle.maxPersons) {
            return {maxPersons: cities[i].vehicle.maxPersons}
          }
        }
      }
    }
    return false
  }

  checkMinPeoplesInCity(persons) {
    const {cities} = this.props;
    const {cityId} = this.state;
    if (cities && cities.length) {
      for (let i = 0; i < cities.length; i++) {
        if (+cities[i].id === +cityId) {
          // console.log(cities[i].vehicle, persons, cities[i].vehicle.minPersons)
          if (cities[i].vehicle && persons < cities[i].vehicle.minPersons) {
            return {minPersons: cities[i].vehicle.minPersons}
          }
        }
      }
    }
    return false
  }

  handleChange(e) {
    let {value} = e.target;
    const {name} = e.target;
    if (name === 'maxPersons' || name === 'minPersons') {
      if (value.length > 10) {
        return null;
      }
      if (!value.match(/[0-9]/)) {
        value = '';
      } else
        value = Math.round(value);
      if (!value) {
        value = ''
      }
    }

    if (name === 'priceOnePerson') {
      value = isFieldPrice(value, this.state.priceOnePerson);
    }

    if (name === 'maxPersons') {
      const isMore = this.checkMaxPeoplesInCity(value);
      if (isMore) {
        this.setState({error: {...this.state.error, 'maxPersons': `Maximum number of people ${isMore.maxPersons}`}});
        return null;
      }
    }

    this.setState({
      [name]: value
    }, () => {
      this.setState({error: {...this.state.error, [name]: ''}}, () => {
        if (name === 'minPersons') {
          const isMore = this.checkMinPeoplesInCity(value);
          if (isMore) {
            this.setState({error: {...this.state.error, 'minPersons': `Minimum number of people ${isMore.minPersons}`}});
          }
        }
      })
    });

    return null;
  }

  handleNewImage(images) {
    this.setState({images, error: {...this.state.error, images: ''}}, () => {
      this.setState({imagesPreview: createPreviewImages(this.state.images, this.deleteImage)})
    })
  }

  handleNewVideo(video) {
    this.setState({video})
  }

  deleteImage(index) {
    const images = [...this.state.images];
    images.splice(index, 1);
    this.setState({images}, () => {
      this.setState({imagesPreview: createPreviewImages(this.state.images, this.deleteImage)})
    })
  }

  handleSetError(error) {
    this.setState({error})
  }

  onNewDates(tourDates) {
    this.setState({tourDates, error: {...this.state.error, tourDates: ''}})
  }

  onNewDayOff(offTourDates) {
    this.setState({offTourDates})
  }

  submitCreate() {

    const validateData = validationTourData(this.state);
    if (validateData.isValid) {

      // Check min max persons in tour
      const isMore = this.checkMaxPeoplesInCity(+this.state.maxPersons);
      if(isMore){
        this.setState({error: {...this.state.error, 'maxPersons': `Maximum number of people ${isMore.maxPersons}`}});
        return null;
      }
      const isMin = this.checkMinPeoplesInCity(+this.state.minPersons);
      if (isMin) {
        this.setState({error: {...this.state.error, 'minPersons': `Minimum number of people ${isMin.minPersons}`}});
        return null;
      }

      const data = {
        active: true,
        title: this.state.title,
        description: this.state.description,
        address: this.state.address,
        lat: this.state.lat,
        lng: this.state.lng,
        tourTemplate: this.state.tourTemplate,
        currencyId: 1,
        cityId: this.state.cityId,
        categoryId: +this.state.categoryId,
        minPersons: +this.state.minPersons,
        maxPersons: +this.state.maxPersons,
        priceOnePerson: +this.state.priceOnePerson,
        tourDates: this.state.tourDates,
        dayOff: this.state.offTourDates,
      };
      this.setState({
        popupData: {
          title: (<div>Loading ...</div>),
          body: (<p className="center-value">Saving now</p>)
        }
      });
      this.props.createTour(data, this.state.images, this.state.video, this.props.history);
    } else {
      this.setState({error: {...this.state.error, ...validateData.error}}, () => {
        this.showErrorNotes(this.state.error)
      });
    }
    return null;
  }

  handleAddress(data) {
    const {address, lat, lng} = data;
    this.setState({address, lat, lng, error: {...this.state.error, address: ''}});
  }

  setTemplate(tmp) {
    this.setState({tourTemplate: tmp})
  }

  showErrorNotes = (err) => {
    const objKeys = Object.keys(err);
    for(let i = 0; i < objKeys.length; i++){
      if(err[objKeys[i]]){
        NotificationManager.error(err[objKeys[i]], '', ((3 + i) * 1000));
      }
    }
  };

  showLastError = () => {
    const {error} = this.state;
    const objKeys = Object.keys(error);
    for(let i = 0; i < objKeys.length; i++){
      if(error[objKeys[i]]){
        return (
          <p className="error-block__tour">
            <i className="fa fa-exclamation" aria-hidden="true" />
            Error: <span>{error[objKeys[i]]}</span>
          </p>
        )
      }
    }
    return ''
  };

  render() {
    const {
      tourTemplate,
      minPersons,
      maxPersons,
      priceOnePerson,
      categoryId,
      images,
      title,
      address,
      description,
      cityId,
      cityOptions,
      popupData,
      offTourDates,
      error,
      imagesPreview
    } = this.state;

    const {
      categories,
      isShowPopup,
      closePopup,
      promiseCreateTour,
    } = this.props;

    return (
      <div className="create-tour">
        {
          isShowPopup &&
          <Popup
            isShow={isShowPopup}
            close={closePopup}
            {...popupData}
          />
        }
        <h2 className="create-tour__title title-page">Create new tour</h2>
        <div className="create-tour__list-steps">
          <div className="create-tour__step">
            <p className="create-tour__step-number">1.</p>
            <div className="input-block select-block">
              {
                error.cityId ?
                  <span className="error-block">{error.cityId}</span> : null
              }
              <span className="input-block__label create-tour__step-title">Select a city</span>
              <Select
                placeholder="City name"
                name="cityId"
                value={cityId}
                onChange={(e) => e && e.value ? this.handleChange({target: {name: 'cityId', value: e.value}}) : null}
                clearable={false}
                options={cityOptions}
              />
            </div>
          </div>
          {/* cityId ?
            <div className="create-tour__step">
              <div className="create-tour__group-block">
                <p className="create-tour__step-number">2.</p>
                <p className="create-tour__step-title">Select a template</p>
              </div>
              <div className="create-tour__list-templates">
                <Button
                  img="/assets/img/template 1.jpg"
                  className={classes({active: tourTemplate === tmpNames.tmp1})}
                  onClick={() => this.setTemplate(tmpNames.tmp1)}
                />
                <Button
                  img="/assets/img/template 2.jpg"
                  className={classes({active: tourTemplate === tmpNames.tmp2})}
                  onClick={() => this.setTemplate(tmpNames.tmp2)}
                />
                <Button
                  img="/assets/img/template 3.jpg"
                  className={classes({active: tourTemplate === tmpNames.tmp3})}
                  onClick={() => this.setTemplate(tmpNames.tmp3)}
                />
              </div>
            </div> : null
          */ }
        </div>
        {
          tourTemplate && cityId ?
            <div className="create-tour__step">
              <div className="create-tour__group-block">
                <p className="create-tour__step-number">2.</p>
                <p className="create-tour__step-title">Tour information</p>
              </div>

              <div className="create-tour__templates-wrap">
                <RenderTemplates
                  tmpProps={{
                    error,
                    minPersons,
                    maxPersons,
                    priceOnePerson,
                    title,
                    categoryId,
                    address,
                    description,
                    images,
                    imagesPreview,
                    categoriesOptions: this.createCategoriesOptions(categories),
                    handleChange: this.handleChange,
                    handleNewImage: this.handleNewImage,
                    handleNewVideo: this.handleNewVideo,
                    handleAddress: this.handleAddress,
                  }}
                  tourTemplate={tourTemplate}
                />
                <TimeSlots
                  errorTourDates={error.tourDates}
                  onUpdatedTimeSlots={(e) => {
                    this.onNewDates(e)
                  }}
                />
                <OffDates
                  offTourDates={offTourDates}
                  onNewDate={this.onNewDayOff}
                />

                <div className="create-tour__buttons">
                  <div className="create-tour__error">
                    {
                      this.showLastError()
                    }
                  </div>
                  <Button
                    disabled={promiseCreateTour.isPending}
                    name="Save the tour"
                    type={buttonTypes.AUTHENTICATION}
                    onClick={this.submitCreate}
                  />
                </div>
              </div>
            </div> : null
        }
        <NotificationContainer />
      </div>
    )
  }
}

export default Tour;


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/Tour/Create/Component.js